export default "__VITE_ASSET__B5I_j4sb__"